import { useCallback, useEffect, useState } from "react";
import { apiService } from "../api/services/apiService";
import type { GatewayRoute } from "../types";

export const useGatewayRoutes = () => {
  const [gatewayRoutes, setGatewayRoutes] = useState<GatewayRoute[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchGatewayRoutes = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await apiService.getGatewayRoutes();
      setGatewayRoutes(data);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : "Failed to load gateway routes");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchGatewayRoutes();
  }, [fetchGatewayRoutes]);

  return { gatewayRoutes, loading, error, refresh: fetchGatewayRoutes };
};
